import { render, staticRenderFns } from "./ListCandidates.vue?vue&type=template&id=3b42c35e&scoped=true&"
import script from "./ListCandidates.vue?vue&type=script&lang=js&"
export * from "./ListCandidates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b42c35e",
  null
  
)

export default component.exports